import { closingColon } from "./helpers.js";

const InputOperations = {
  isTrue: (arg) => {
    let matcher = /\btm/;
    return matcher.test(arg);
  },

  hasOpened: false,
  // should have a name which is a proper variable
  getInputName: (arg) => {
    let inputName = arg.trim().split("")[1];
    if (!inputName) {
      console.log("input should have a name");
    }
  },

  openingColon: (arg) => {
    arg = arg.replace(/\btm\b/, "<input ").replace(":", "");
    return arg;
  },
};

export const runInputOperations = (readLinesOriginal, readLines, errors) => {
  for (let i = 0; i < readLines.length; i++) {
    let x = readLines[i];
    if(InputOperations.isTrue(x)){
        closingColon(readLines,i,InputOperations,`</input>`)
        readLines[i] = InputOperations.openingColon(x);
    }
  }
  return readLines
};
